"use client";

import { ReactNode } from "react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { ConvexReactClient } from "convex/react";
import { useAuth } from "@clerk/nextjs";
import { UserInitializer } from "@/components/UserInitializer";
import AuthErrorBoundary from "@/components/AuthErrorBoundary";

const convex = new ConvexReactClient(process.env.NEXT_PUBLIC_CONVEX_URL!);

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  return (
    <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
      {/* Catches "Authentication required" throws from any subscribed query
          during the sign-out / token-expiry race. It must wrap EVERYTHING that
          can call useQuery. See AuthErrorBoundary for the full rationale. */}
      <AuthErrorBoundary>
        <UserInitializer>{children}</UserInitializer>
      </AuthErrorBoundary>
    </ConvexProviderWithClerk>
  );
}